import * as React from 'react';
import { TaLoaderPage } from './ta-loader-page/comp';
import { TaQuestionsPage } from './ta-questions-page/comp';
import { TaResultPage } from './ta-result-page/comp';
import { getTaQuestions, getTaAnswers, mapUsersAnswers } from './ta-services/ta-content-service';
import { addLocalState, TaUserObject, updateLocalState } from './ta-services/ta-user-service';
import { TaQuestionData, TaAnswerData } from './ta-shared';
import { TaWelcomePage } from './ta-welcome-page/comp';

export type TechAssessmentState = {
	fullName: string;
	email: string;
	company: string;
	step: number;
	answers: string[];
	_id?: string;
	phase: string;
	isAppLoading: boolean;
	questionsData: TaQuestionData[];
	answerssData: TaAnswerData[];
	initTime?: number;
};

export class TechAssessment extends React.PureComponent<{}, TechAssessmentState> {
	state: TechAssessmentState = {
		fullName: '',
		email: '',
		company: '',
		phase: 'WELCOME',
		isAppLoading: true,
		questionsData: [],
		answerssData: [],
		step: 0,
		answers: [],
		initTime: new Date().getTime()
	};

	componentDidMount () {
		Promise.all([getTaQuestions(), getTaAnswers()]).then((results) => {
			this.setState({
				questionsData: [...results[0]],
				answerssData: [...results[1]],
			});
		});
	}

	handleUserSignup = async (newUser: TaUserObject) => {
		const user = await addLocalState(newUser);
		this.setState({
			fullName: user.fullName,
			email: user.email,
			company: user.company,
			step: user.step ? user.step : this.state.step,
			answers: user.answers ? user.answers : this.state.answers,
			_id: user._id,
			phase: 'ASSESSMENT',
			initTime: user.initTime
		});
	}

	handleUserReturn = (user: TaUserObject) => {
		this.setState({
			fullName: user.fullName,
			email: user.email,
			company: user.company,
			step: user.step ? user.step : this.state.step,
			answers: user.answers ? user.answers : this.state.answers,
			_id: user._id,
			phase: user.step! < 18 ? 'ASSESSMENT' : 'RESULT',
		});
	}

	handleUserAnswer = (value?: string) => {
		this.setState({
			answers: value ? [...this.state.answers, value] : [...this.state.answers],
			step: this.state.step + 1
		}, () => {
			const {fullName, email, company, step, answers, _id, initTime} = this.state;
			updateLocalState({fullName, email, company, step, answers, _id, initTime});
			if (this.state.step === 18) {
				this.setState({phase: 'RESULT'});
			}
		});
	}

	renderComp = () => {
		const { phase, questionsData, step, fullName, email, company, answers, answerssData } = this.state;
		if (phase === 'WELCOME') {
			return (
				<TaWelcomePage
					onUserSignup={this.handleUserSignup}
					onUserReturn={this.handleUserReturn}
				/>
			);
		}

		if (phase === 'ASSESSMENT' && questionsData.length) {
			return (
				<TaQuestionsPage
					questionsData={questionsData}
					step={step}
					onUserAnswer={this.handleUserAnswer}
				/>)
			;
		}

		if (phase === 'RESULT' && answerssData.length) {
			const userAnswerssData = mapUsersAnswers(answers, answerssData);
			return (
				<TaResultPage
						fullName={fullName}
						company={company}
						email={email}
						userAnswerssData={userAnswerssData}
				/>);
		}

		return <TaLoaderPage />;
	}

	render () {
		return (
			<div className='tech-assessment-container'>{this.renderComp()}</div>
		);
	}
}
